export default __webpack_public_path__ + "static/media/extruder-right.09cc6735.svg";